import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {UsersService} from '@ose/services';
import {catchError, map, of} from "rxjs";

export const KycGuard: CanActivateFn = () => {
  const usersService = inject(UsersService);
  const router = inject(Router);

  return usersService.hasConfirmedCards().pipe(
    map((res: boolean) => {
      if (!res) {
        router.navigate(['/kyc-required']);
        return res;
      }
      return res;
    }),
    catchError(() => {
      router.navigate(['/kyc-required']);
      return of(false);
    })
  );
};
